import Plugin from 'src/plugin-system/plugin.class';
import Flickity from 'flickity';

export default class ImageSliderPlugin extends Plugin {

    init() {

        var flkty = new Flickity( this.el, {
            pageDots: true,
            //wrapAround: false,
            cellAlign: 'left',
            prevNextButtons: false,
            groupCells: 2,
            selectedAttraction: 0.2,
            friction: 0.8
        });

    }

}